import styled from "@emotion/styled";

import { SCMPYoutubeVideo } from "scmp-app/components/scmp-youtube-video";

export const StyledSCMPYoutubeVideo = styled(SCMPYoutubeVideo)``;
